var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('title-inv-1',{attrs:{"title":"Facturas"}}),_c('cards-invoice',{staticStyle:{"margin-top":"-24px"}}),_c('title-inv-1',{staticStyle:{"margin-top":"-24px"},attrs:{"title":"Histórico Mensal"}}),_c('month-historic')],1)}
var staticRenderFns = []

export { render, staticRenderFns }